import BrandArticle from "@/pages/article/components/BrandArticle";
import { brandArticles } from "@/mocks/brandArticles";

const data = brandArticles.find((a) => a.slug === "superbuy-spreadsheet")!;

export default function SuperbuySpreadsheetPage() {
  return <BrandArticle data={data} />;
}